// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { SendVerificationEmailInput } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: SendVerificationEmailMutation
// ====================================================

export interface SendVerificationEmailMutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface SendVerificationEmailMutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: SendVerificationEmailMutation_output_errors_extendedMessages[];
}

export interface SendVerificationEmailMutation_output_session {
  /**
   * The email of the currently logged-in user, or null if not logged-in. Note that
   * this can be an empty string if the user hasn't yet given us their email.
   */
  email: string | null;
  /**
   * Whether the user's email address has been verified, or null if not logged-in.
   */
  isEmailVerified: boolean | null;
}

export interface SendVerificationEmailMutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: SendVerificationEmailMutation_output_errors[];
  session: SendVerificationEmailMutation_output_session | null;
}

export interface SendVerificationEmailMutation {
  /**
   * Sends the currently logged-in user an email with a link
   * to follow; when they follow the link, their account will be marked
   * as having a verified email address.
   * 
   * Note that this endpoint requires the user's email address. If
   * the one provided is different from the one they currently have
   * set, it will be changed, and their account will be marked as
   * having an unverified email address (until they click on the
   * link that has been sent to them, of course).
   */
  output: SendVerificationEmailMutation_output;
}

export interface SendVerificationEmailMutationVariables {
  input: SendVerificationEmailInput;
}

export const BlankSendVerificationEmailInput: SendVerificationEmailInput = {
  "email": ""
};

export const SendVerificationEmailMutation = {
  // The following query was taken from SendVerificationEmailMutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation SendVerificationEmailMutation($input: SendVerificationEmailInput!) {
  output: sendVerificationEmail(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      email,
      isEmailVerified
    }
  }
}
${ExtendedFormFieldErrors.graphQL}`,
  name: "SendVerificationEmailMutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: SendVerificationEmailMutationVariables): Promise<SendVerificationEmailMutation> {
    return fetchGraphQL(SendVerificationEmailMutation.graphQL, args);
  },
  blankInput: BlankSendVerificationEmailInput,
};

export const fetchSendVerificationEmailMutation = SendVerificationEmailMutation.fetch;